import { render } from "./CollapsibleSection.vue?vue&type=template&id=353f0f19&ts=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__